import React, { useState, useEffect } from "react";
import ClinicOverviewForm from "./ClinicOverviewForm";
import clinicService from "../../../../../services/clinic.service";
import { useParams } from "react-router-dom";

const ClinicOverview = ({updateLogo}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clinic, setClinic] = useState({});
  const { clinicId } = useParams();

  useEffect(() => {
    setIsLoading(true);
    clinicService
      .getClinicById(clinicId)
      .then((clinic) => {
        setClinic(clinic.data);
        updateLogo(clinic.data.logo)
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <>
    <div className="d-flex flex-column flex-fill me-3">
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Clinic Overview
        </h5>
        <div>
          {isEditing ? (
            <button
              className="btn btn-secondary btn-sm mt-2"
              onClick={() => setIsEditing(false)}
            >
              <i className="bi bi-x-square bi-sm"></i> Cancel
            </button>
          ) : (
            <button
              className="btn btn-secondary btn-sm mt-2"
              onClick={() => setIsEditing(true)}
            >
              <i className="bi bi-pencil-square bi-sm"></i> Edit
            </button>
          )}
        </div>
      </div>

      {isLoading ? (
        <div className="loader"></div>
      ) : isEditing ? (
        <ClinicOverviewForm clinic={clinic} />
      ) : (
        <div className="clinic-overview table-responsive mb-3">
          <table className="table table-striped">
           <tbody>
              <tr>
                <td>Status</td>
                <td>
                {clinic.status ? (
                <span className="text-success">Active</span>
              ) : (
                <span className="text-danger">Inactive</span>
              )}
                </td>
              </tr>
              <tr>
                <td>Type:</td>
                <td>
                 {clinic.clinicType}
                </td>
              </tr>
              <tr>
                <td>Name:</td>
                <td>{clinic.name}</td>
              </tr>
              <tr>
                <td>Email:</td>
                <td>{clinic.email}</td>
              </tr>
              <tr>
                <td>Phone:</td>
                <td>{clinic.phone}</td>
              </tr>
              <tr>
                <td>SMS:</td>
                <td>{clinic.sms}</td>
              </tr>
              <tr>
                <td>Signature:</td>
                <td>{clinic.signature}</td>
              </tr>
              <tr>
                <td>Logo:</td>
                <td><span className="text-wrap">{clinic.logo}</span></td>
              </tr>
              <tr>
                <td>Website:</td>
                <td>{clinic.website}</td>
              </tr>
              <tr>
                <td>Created:</td>
                <td>{clinic.dateCreated}</td>
              </tr>
              <tr>
                <td>Modified:</td>
                <td>{clinic.dateModified}</td>
              </tr>
              <tr>
                <td>Start Date:</td>
                <td>{clinic.dateStarted}</td>
              </tr>
            </tbody>    
           
          </table>
       
        </div>
      )}
      </div>
    </>
  );
};

export default ClinicOverview;
